import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { Item } from '../../../../common/snippets'
import { focusElemnt } from '../../../../common/helper'
import * as mdt from '../../../../common/modaltypes'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const AssignFormatModal = (props) => {
  const { updateModal, headTxt, isUpdate, branchList, AssignCargoTicketFormat, loginData, mode, TicketFormatID } = props
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [selectedBranches, setSelectedBranches] = useState({})
  const [filterValues, setFilterValues] = useState({})
  const [filteredData, setFilteredData] = useState(branchList)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const columnDefs = [
    {
      headerName: tr('gsStatus', 'Status'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '2%' },
      field: 'select',
      dataType: 'string',
      showfilter: false,
      allowSorting: false,
    },
    {
      headerName: tr('branchName', 'Branch Name'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '12%' },
      field: 'BranchName',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
    {
      headerName: tr('wbCurrentlyAssignedFormat', 'Currently Assigned Format'),
      headerSx: { padding: '6px 12px', textAlign: 'left', minWidth: '10%' },
      field: 'TicketFormatName',
      dataType: 'string',
      showfilter: true,
      allowSorting: false,
    },
  ]
  const handleCheckboxChange = (branchID) => {
    setSelectedBranches((prevSelectedBranches) => {
      return {
        ...prevSelectedBranches,
        [branchID]: !prevSelectedBranches[branchID], // Toggle the value
      }
    })
  }

  useEffect(() => {
    focusElemnt('selAutoDelByCity')
  }, [])

  useEffect(() => setFilteredData(branchList), [branchList])

  useEffect(() => {
    const filtered = (branchList || []).filter((item) =>
      columnDefs.every((col) => {
        const filterValue = filterValues[col.field] || ''
        const value = item[col.field]
        return filterValue ? value?.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    )
    setFilteredData(filtered)
  }, [filterValues, branchList])

  const handleChangeContain = (e, name) => {
    setFilterValues((prev) => ({ ...prev, [name]: e.target.value }))
  }

  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={3}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>{tr('noResultsSelectedFilters', 'No results found for the selected filters.')}</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }

  const InsideRowContent = (props) => {
    const { item, index } = props
    return (
      <TableRow key={`auto-trans-recv-${index}`} style={{ minHeight: '36px' }}>
        <TableCell
          style={{ textAlign: '-webkit-center', fontSize: '12px', minHeight: '36px', color: '#444444', width: '2%', padding: '0px 8px' }}
        >
          <Item className="checkbox-ctrl" style={{ padding: '0px 8px', backgroundColor: 'transparent' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id={`chkbox-${index}`}
                  checked={selectedBranches[item.BranchID] || false}
                  onChange={() => handleCheckboxChange(item.BranchID)}
                  sx={{ fontSize: '12px', backgroundColor: 'transparent !important', height: '36px', verticalAlign: 'middle' }}
                />
              }
              labelPlacement="end"
            />
          </Item>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '36px', color: '#444444', width: '12%', padding: '0px 8px' }}>
          {item.BranchName}
        </TableCell>
        <TableCell style={{ textAlign: 'left', fontSize: '12px', minHeight: '36px', color: '#444444', width: '10%', padding: '0px 8px' }}>
          {item.TicketFormatName}
        </TableCell>
      </TableRow>
    )
  }
  const handleSave = () => {
    const branchIDs = Object.keys(selectedBranches).filter(key => selectedBranches[key]);
    branchIDs.forEach((branchID) => {
      const body = {
        intBranchID: parseInt(branchID),
        intTicketFormatID: parseInt(TicketFormatID),
        Mode: mode,
      }
      AssignCargoTicketFormat(body)
        .then((res) => {
          if (res.status === 'Success') {
            updateModal(false, mdt.ticketFormat)
          } else {
            // Handle error for each branchID if needed
          }
        })
        .catch((err) => {
          console.log('Error:', err)
          // Handle error for each branchID if needed
        })
    })

    // Additional logic after all API calls, if needed
  }

  return (
    <Modal
      headTxt={headTxt}
      width={'40%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Stack style={{ maxHeight: '60vh', paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px' }}>
        <TableContainer
          className="lr-popup-table lrModel  scrollBlue"
          style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }}
          component={Paper}
        >
          <Table
            style={{ border: 'none', overflow: 'auto' }}
            stickyHeader
            id="focApprovalTbl"
            className="table1 table-Received "
            size="small"
            aria-label="a dense table"
          >
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key="foc-tbl-header" style={{ background: '#d9edff', height: '36px' }}>
                {columnDefs.map((col, index) => (
                  <TableCell
                    key={`TH-${index}`}
                    style={{
                      ...col.headerSx,
                      verticalAlign: 'top',
                      backgroundColor: '#DAEDFE',
                      minHeight: '36px',
                      fontFamily: 'Roboto',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#444444',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {col.headerName.split('\n').map((line, lineIndex) => (
                        <span key={`line-${lineIndex}`} style={{}}>
                          {line}
                        </span>
                      ))}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                {columnDefs.map((col, index) =>
                  col.showfilter ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`modal-filter-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder={tr('contains', 'Contains')}
                          onChange={(e) => handleChangeContain(e, col.field)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell key={`FTH-${index}`}></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            {filteredData?.length > 0 ? (
              <TableBody className="filter-data-row" style={{ border: 'none' }}>
                {filteredData.map((item, index) => (
                  <InsideRowContent item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <EmptyTableRow />
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <Box sx={{ display: 'flex', padding: '12px 0px' }}>
          <Button
            className="cancel-btn"
            variant="outlined"
            color="error"
            style={{ height: '40px', color: '#fe5200', fontSize: 'medium', marginLeft: 'auto', marginRight: '12px' }}
            onClick={() => {
              isUpdate ? updateModal(false, mdt.ticketFormat) : updateModal(false, mdt.ticketFormat)
            }}
          >
            {tr('cancel', 'Cancel')}
          </Button>
          <Button
            id="mopAddBtn"
            style={{ margin: '0', height: '40px' }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={() => {
              handleSave()
            }}
          >
            {isUpdate ? tr('updateTitle', 'Update') : tr('saveTitle', 'Save')}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}

export default AssignFormatModal
